import script from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=1a1262e4&lang=scss"

const __exports__ = script;

export default __exports__